<template>
  <div class="notice_mng">
    <!-- 搜索 -->
    <el-form
      :model="formData"
      ref="form"
      :inline="true"
      label-width="100px"
      class="form-box"
    >
      <el-form-item label="姓名：" prop="truename">
        <el-input
          v-model="formData.truename"
          placeholder="请输入"
          clearable
          size="small"
        />
      </el-form-item>

      <el-form-item label="手机号：" prop="tel">
        <el-input v-model="formData.tel" placeholder="请输入" clearable size="small" />
      </el-form-item>

      <el-form-item label="购买状态：" prop="status">
        <el-select
          v-model="formData.status"
          placeholder="请选择"
          clearable
          filterable
          :style="{ width: '100%' }"
          size="small"
        >
          <el-option
            v-for="(item, index) in statusOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="单位：" prop="unit" v-if="roleType == 0">
        <el-select
          v-model="formData.unit"
          placeholder="请选择单位"
          clearable
          filterable
          remote
          :remote-method="remoteMethod"
          :style="{ width: '100%' }"
          size="small"
        >
          <el-option
            v-for="(item, index) in unitList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="性别：" prop="sexy">
        <el-select
          v-model="formData.sexy"
          placeholder="请选择性别"
          clearable
          filterable
          :style="{ width: '100%' }"
          size="small"
        >
          <el-option
            v-for="(item, index) in sexyOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label=" ">
        <el-button type="primary" size="small" @click="formQuery()">查询</el-button>
        <el-button size="small" @click="formReset('form')">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="operate-box">
      <el-button type="primary" size="small" @click="buy()">申请购买</el-button>
      <el-button size="small" @click="download()">导出</el-button>
      <el-button size="small" @click="buyState()">批量更改购买状态</el-button>
    </div>

    <ComTable
      ref="table"
      :filter="formData"
      :api="tableApi"
      @selection-change="tableSelectionChange"
    >
      <ComTableColumn
        type="selection"
        width="45"
        header-align="center"
        align="center"
        :selectable="selectable"
      ></ComTableColumn>
      <ComTableColumn
        label="姓名"
        width="150"
        header-align="center"
        align="center"
        column_type="3"
      >
        <template slot-scope="scope">
          {{ scope.row.truename || scope.row.username }}
          <template v-if="roleType == 1">
            <span class="public-label-1 ml6" v-if="scope.row.is_teacher == 1">
              主班
            </span>
            <span class="public-label-1 ml6" v-if="scope.row.is_teacher == 2">
              副班
            </span>
          </template>
        </template>
      </ComTableColumn>
      <ComTableColumn
        label="性别"
        width="60"
        header-align="center"
        align="center"
        column_type="3"
      >
        <template scope="scope">
          {{ scope.row.sexy || scope.row.sex }}
        </template>
      </ComTableColumn>
      <ComTableColumn
        label="手机号"
        width="120"
        header-align="center"
        align="center"
        column_type="3"
      >
        <template scope="scope">
          {{ scope.row.tel || scope.row.phone }}
        </template>
      </ComTableColumn>
      <ComTableColumn
        label="单位"
        header-align="center"
        align="center"
        column_type="3"
        v-if="roleType != 1"
      >
        <template scope="scope">
          {{ scope.row.unit_name || scope.row.class_name || scope.row.org_name }}
        </template>
      </ComTableColumn>
      <!-- <ComTableColumn label="方案" header-align="center" align="center" column_type="3">
        <template scope="scope">
          {{ scope.row.type_name || scope.row.insurance_name }}
        </template>
      </ComTableColumn>
      <ComTableColumn
        prop="cost"
        label="单价"
        width="100"
        header-align="center"
        align="center"
      ></ComTableColumn> -->
      <ComTableColumn
        prop="status_name"
        label="购买状态"
        width="100"
        header-align="center"
        align="center"
      ></ComTableColumn>
    </ComTable>
    <AddInsureDialog
      ref="addInsureDialog"
      @update="addInsureDialogUpdate"
      :postApiBuy="postApiBuy"
      :roleType="roleType"
    ></AddInsureDialog>

    <!--编辑录入状态-->
    <BuyStatus ref="buyStatus" @submitScuuess="submitScuuess"></BuyStatus>
  </div>
</template>

<script>
import { GetUnitList } from "@/api/tearcher";
import AddInsureDialog from "@/components/dialog/AddInsureDialog.vue";
import BuyStatus from "@/components/BuyStatus/index.vue";
export default {
  components: {
    AddInsureDialog,
    BuyStatus,
  },
  props: {
    //保险列表接口
    getApiList: {
      type: Function,
      default: () => {},
    },
    //保险列表导出接口
    getApiExport: {
      type: Function,
      default: () => {},
    },
    //保险购买接口
    postApiBuy: {
      type: Function,
      default: () => {},
    },
    //角色类型
    roleType: {
      type: Number,
      default: "0",
    },
  },
  data() {
    return {
      tableApi: this.getApiList, //表格接口
      tableSelection: [], //表格选择项
      //表单数据
      formData: {
        class_id: sessionStorage.getItem("class_id"),
        truename: "",
        tel: "",
        sexy: "",
        unit: "",
        status: "",
      },
      //购买状态选项
      statusOptions: [
        {
          label: "未购买",
          value: 3,
        },
        {
          label: "申请中",
          value: 1,
        },
        {
          label: "已购买",
          value: 2,
        },
      ],
      //性别选项
      sexyOptions: [
        {
          label: "男",
          value: 1,
        },
        {
          label: "女",
          value: 2,
        },
      ],
      unitList: [], //单位列表
    };
  },
  methods: {
    //表单查询
    formQuery() {
      this.$refs["table"].initialize();
    },
    //表单重置
    formReset(formName) {
      this.$refs[formName].resetFields();
      this.$refs["table"].initialize();
    },
    //单位搜索
    remoteMethod(keyword) {
      this.getUnitList(keyword);
    },
    //获取单位列表
    getUnitList(search) {
      GetUnitList({ search }).then((res) => {
        this.unitList = res.data;
      });
    },
    //导出
    download() {
      let formData = JSON.parse(JSON.stringify(this.formData));
      formData.is_export = 1;
      this.getApiExport(formData).then((res) => {
        let roleName = "";
        if (this.roleType == 0) {
          roleName = "学员";
        }
        if (this.roleType == 1) {
          roleName = "班主任";
        }
        if (this.roleType == 2) {
          roleName = "专家";
        }
        saveAs(res, `${roleName}保险购买表.xls`);
      });
    },
    //申请购买
    buy() {
      if (this.tableSelection.length == 0) {
        this.$message({
          message: "请选择表格数据",
          type: "warning",
          duration: messageDuration,
        });
        return;
      }
      this.$refs["addInsureDialog"].open({ tableSelection: this.tableSelection });
    },
    //表格选择回调
    tableSelectionChange(selection) {
      this.tableSelection = [];
      selection.forEach((item) => {
        this.tableSelection.push(item);
      });
    },
    //表格选择
    selectable(row, index) {
      return row.status == 0 || row.status == null;
    },
    //购买保险弹窗更新回调
    addInsureDialogUpdate() {
      this.formQuery();
    },
    //批量更改购买状态
    buyState() {
      if (this.tableSelection.length == 0) {
        this.$message({
          message: "请选择表格数据",
          type: "warning",
          duration: messageDuration,
        });
        return;
      }
      this.$refs.buyStatus.operationDialog(this.roleType, this.tableSelection);
    },
    //弹窗操作完成回调
    submitScuuess() {
      this.formQuery();
    },
  },
  created() {
    if (this.roleType == 0) {
      this.statusOptions[0].value = 0;
    }
    this.getUnitList(); //获取单位列表
  },
};
</script>

<style lang="less" scoped>
.form-box {
  padding: 20px 0 10px 0;
  background: #f7f7f7;
  .el-form-item {
    margin-bottom: 10px;
  }
}
.operate-box {
  padding: 30px 0 10px 0;
}
</style>
